(ns score-adjuster.model)

;; TODO lifted from wandi.submissions.adjust-scores remove once hooked up and finished

(def adjusted-scoring-engines
  #{:ielts :ielts-academic :ielts-general :fce})

;; TODO lifted from wandi.tasks.common task-definitions remove when appropriate
(def scoring-model-definition
  {:cefr :cefr
   :ielts :ielts
   :ielts-academic :ielts
   :ielts-general :ielts
   :fce :fce})

;;TODO this was lifted from wandi.achievements.scores remove from wandi when finished

(def ^:private scoring-model->score-definition
  "Ranges are used for score calculation: they
   are a vector of tuples: [raw-score ces-score description],
   where description is either a string or a pair:
   [short-description long-description].

   The min-description is shown if the score is below
   all of the defined ranges."
  {:cefr-level {:min-description "A1-"
                :ranges [[1.5 100 "A1"]
                         [3.5 120 "A2"]
                         [5.5 140 "B1"]
                         [7.5 160 "B2"]
                         [9.5 180 "C1"]
                         [11.5 200 "C2"]
                         [13.5 220 "C2+"]]}

   :ces-score {:min-description "-"
               :ranges [[80 80 "80"]
                        [230 230 "230"]]}

   :est-raw-score {:min-description "80"
                   :ranges [[0.0 80]
                            [0.5 100]
                            [1.5 110]
                            [2.0 120]
                            [2.5 130]
                            [3.0 140]
                            [3.5 150]
                            [4.0 160]
                            [4.5 170]
                            [5.0 180]
                            [5.5 190]
                            [5.8 200]]}

   :ielts-score {:min-description "3.5 or less"
                 :offset -0.25
                 :ranges [[4.0 142 "4"]
                          [4.5 147 "4.5"]
                          [5.0 154 "5"]
                          [5.5 162 "5.5"]
                          [6.0 169 "6"]
                          [6.5 176 "6.5"]
                          [7.0 185 "7"]
                          [7.5 191 "7.5"]
                          [8.0 200 "8"]
                          [8.5 205 "8.5"]
                          [9.0 208.2 "9"]]}

   :fce-grade {:min-description "-"
               :ranges [[140 140 ["Level B1" "B1"]]
                        [160 160 ["Pass at Grade C" "C"]]
                        [173 173 ["Pass at Grade B" "B"]]
                        [180 180 ["Pass at Grade A" "A"]]
                        [190 190 ["Pass at Grade A" "A"]]]}})

(defn get-description
  [band]
  (nth band 2))

(defn ranges-for
  [score-type]
  (get-in scoring-model->score-definition [score-type :ranges]))

(defn ces-ranges-for
  [score-type]
  (->> (ranges-for score-type)
       (map (fn [[raw-score ces-score & more]]
              (apply vector ces-score raw-score more)))
       not-empty))

(defn- in-range?
  [[minima maxima] x]
  (and minima maxima
       (>= x minima)
       (< x maxima)))

(defn- convert-linear
  "Converts the score using a linear mapping based on the from-band:to-band ratio"
  [score [from-band-min to-band-min] [from-band-max to-band-max] ranges]
  (let [num-bands (dec (count ranges))
        [from-minima to-minima] (first ranges)
        [from-maxima to-maxima] (last ranges)
        approx-from-band (/ (- from-maxima from-minima)
                            num-bands)
        approx-to-band (/ (- to-maxima to-minima)
                          num-bands)]
    (max 0
         (+ to-band-min
            (* (/ (- score from-band-min)
                  approx-from-band)
               approx-to-band)))))

(defn- convert
  "Given a coll of [from-band to-band] pairs and a from-score, computes a
   score that's mapped and interpolated on to the to-band.

   A linear mapping is used where the score falls outside of the range."
  [score ranges]
  (some (fn [[[from-band-min to-band-min :as band-mins]
              [from-band-max to-band-max :as band-maxes]]]
          (let [from-minima (ffirst ranges)]
            (cond
              (in-range? [from-band-min from-band-max]
                         score)
              (+ to-band-min
                 (* (- to-band-max to-band-min)
                    (/ (- score from-band-min)
                       (- from-band-max from-band-min))))

              (or (< score from-minima)
                  (nil? to-band-max))
              (convert-linear score band-mins band-maxes ranges))))
        (partition-all 2 1 ranges)))

(defn to-ces-score
  [score-type raw-score]
  (when raw-score
    (if-let [ranges (ranges-for score-type)]
      (convert raw-score ranges)
      raw-score)))

(defn from-ces-score
  [score-type ces-score]
  (when ces-score
    (if-let [ces-ranges (ces-ranges-for score-type)]
      (convert ces-score ces-ranges)
      ces-score)))

(defn- score-offset
  [score-type]
  (get-in scoring-model->score-definition
          [score-type :offset]
          0))

(defn score-type-supported?
  [score-type]
  (boolean
   ((set (keys scoring-model->score-definition)) score-type)))

(defn description-for
  [score-type ces-score]
  ;; convert back to the raw score to compute the description
  ;; as we need to apply the band offset (e.g. IELTS 3.75 gets
  ;; rounded up to 4
  (when (score-type-supported? score-type)
    (let [offset (score-offset score-type)
          raw-score (from-ces-score score-type ces-score)
          ranges (ranges-for score-type)]
      (cond
        (< raw-score (+ (ffirst ranges) offset))
        (get-in scoring-model->score-definition
                [score-type
                 :min-description])

        (>= raw-score (+ (first (last ranges)) offset))
        (get-description (last ranges))

        :in-range
        (some (fn [[[raw-band-min ces-band-min description]
                    [raw-band-max ces-band-max]]]
                (when (in-range? [(+ raw-band-min offset)
                                  (+ raw-band-max offset)]
                                 raw-score)
                  description))
              (partition-all 2 1 ranges))))))
